import axios from 'axios'

const state = {
  courts: []
};

const actions = {
  getAllCourts ({commit}) {
    axios.post('api/courts/items', {per_page: 0}).then(
      response => {
        commit('recieve_courts', response.data.data)
      }
    ).catch(errors =>{
      console.log(errors);
    })
  },
};

const mutations = {
  recieve_courts (state, courts) {
    state.courts = courts;
  },
};

const getters = {
  allCourts (state) {
    return state.courts
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}
